import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumFormatter' })

//  This pipe returns an enum value as a case-separated string value.
export class EnumFormatterPipe implements PipeTransform {
  transform(value: number, enumType: any): any {
    return enumType[value].split(/(?=[A-Z])/).join().replace(',', ' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/enum-formatter.pipe.ts